import { v4 as uuid } from 'uuid';

export class WeightEntity {
  id: string = uuid();

  constructor(
    public weight: number,
    public date: Date = new Date(),
    public deleted = false,
    public calories: number | null = null
  ) {}
}

export interface Weight extends WeightEntity {
  bordered: boolean;
}
